import { Cell, Grid } from 'bold-ui'
import { DateField, NumberField, TextField, UfSelectField } from 'components/form'
import { css } from 'emotion'
import { useServerTime } from 'hooks/useServerTime'
import { toDate } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

import { CidadaoAldeadoFormModel } from '../types/model-cidadao'
import { FormSectionAccordionWithErrors } from './FormSectionAccordionWithErrors'

interface RaniSaudeIndigenaFormSectionProps {
  meta: MetaPath<CidadaoAldeadoFormModel>
  dataNascimento?: string
}

export const RaniSaudeIndigenaFormSection = ({ meta, dataNascimento }: RaniSaudeIndigenaFormSectionProps) => {
  const { getServerTimeNow } = useServerTime()
  const now = getServerTimeNow()

  const dtNascimento = dataNascimento ? toDate(dataNascimento) : undefined

  return (
    <FormSectionAccordionWithErrors
      name={meta.openedAccordionRani}
      title='RANI - Registro Administrativo de Nascimento Indígena'
      uuid='raniSaudeIndigena'
      textStyle={css`
        font-size: 1rem;
      `}
    >
      <Grid
        style={css`
          padding: 1rem;
          padding-top: 2rem;
          padding-bottom: 2.5rem;
        `}
      >
        <Cell size={3}>
          <TextField name={meta.unidadeFunai} maxLength={40} label='Unidade da FUNAI' />
        </Cell>
        <Cell size={3}>
          <NumberField name={meta.livro} maxLength={8} label='Livro' />
        </Cell>
        <Cell size={3}>
          <NumberField name={meta.folha} maxLength={4} label='Folha' />
        </Cell>
        <Cell size={3}>
          <TextField name={meta.cadastroUnico} maxLength={20} label='Nº Cadastro Único' />
        </Cell>
        <Cell size={3}>
          <DateField name={meta.dtEmissao} minDate={dtNascimento} maxDate={now} label='Data de Emissão' />
        </Cell>
        <Cell size={3}>
          <UfSelectField name={meta.ufNascimento} label='UF de Nascimento' />
        </Cell>
        <Cell size={6} />
      </Grid>
    </FormSectionAccordionWithErrors>
  )
}
